import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddComponent } from './add/add.component';
import { ListComponent } from './list/list.component';
import { ViewComponent } from './view/view.component';

const routes: Routes = [
  {
    path:'',
    children:[
      { path:'' , redirectTo:'list' , pathMatch:'full'},
      {
        path:'list',component:ListComponent
      },
      {
        path:'add',component:AddComponent
      },
      {
        path:'view/:id',component:ViewComponent
      },
      {
        path:'edit',component:AddComponent
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ResourcesRoutingModule { }
